import { FunctionComponent } from 'react';
import { MediaGalleryLightBoxContent } from './MediaGalleryLightBoxContent';
import { MediaGalleryLightBoxProvider } from '../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';
import { Modal } from '@property.com.au/ui-kit';

export const mediaGalleryLightBoxId = 'MediaGalleryLightBox';

export interface MediaGalleryLightBoxProps {
  opened: boolean;
  onClose: () => void;
  openAction: string;
  initialImageIndex?: number;
  galleryItemKey?: string;
}

export const MediaGalleryLightBox: FunctionComponent<MediaGalleryLightBoxProps> = ({
  opened,
  onClose,
  openAction,
  initialImageIndex,
  galleryItemKey,
}) => {
  return (
    <Modal
      opened={opened}
      getAppElement={() => '#argonaut-wrapper'}
      onRequestClose={onClose}
      reactModalProps={{
        id: mediaGalleryLightBoxId,
        contentLabel: 'Media Gallery LightBox',
        style: {
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
          },
          content: {
            padding: 0,
            width: '100%',
            height: '100%',
          },
        },
      }}
    >
      <MediaGalleryLightBoxProvider
        openAction={openAction}
        initialImageIndex={initialImageIndex}
        galleryItemKey={galleryItemKey}
      >
        <MediaGalleryLightBoxContent onClose={onClose} opened={opened} />
      </MediaGalleryLightBoxProvider>
    </Modal>
  );
};
